import React from 'react';
import { FileSearch, ClipboardCheck, Calculator, Map, Check } from 'lucide-react';
import { solutionData } from '../../data/mock';

const SolutionSection = () => {
  const stepIcons = [FileSearch, ClipboardCheck, Calculator, Map];

  return (
    <section id="solucao" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-amber-50 text-amber-700 text-sm font-medium rounded-full mb-4">
            A Solução
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-4">
            {solutionData.title}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            {solutionData.subtitle}
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {solutionData.steps.map((step, index) => {
            const Icon = stepIcons[index];
            return (
              <div
                key={index}
                className="relative group"
              >
                {/* Connector Line */}
                {index < solutionData.steps.length - 1 && (
                  <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-stone-200 -translate-x-1/2 z-0" />
                )}
                
                <div className="relative bg-white rounded-2xl p-6 border border-stone-200 hover:border-amber-200 hover:shadow-lg transition-all duration-300 h-full z-10">
                  {/* Step Number */}
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-12 h-12 bg-amber-600 rounded-xl flex items-center justify-center shadow-lg shadow-amber-600/25">
                      <Icon className="w-5 h-5 text-white" />
                    </div>
                    <span className="text-4xl font-bold text-stone-100 group-hover:text-amber-100 transition-colors">
                      {step.number}
                    </span>
                  </div>

                  {/* Content */}
                  <h3 className="text-lg font-bold text-slate-800 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Deliverables */}
        <div className="bg-gradient-to-br from-amber-50 to-stone-50 rounded-2xl p-8 lg:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-slate-800 mb-4">
                O Que Você Recebe
              </h3>
              <p className="text-slate-600 mb-6">
                Um diagnóstico completo e um plano de ação claro para sua construtora participar de licitações com segurança.
              </p>
              <ul className="space-y-3">
                {solutionData.deliverables.map((item, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <div className="w-6 h-6 bg-amber-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <Check className="w-3.5 h-3.5 text-white" />
                    </div>
                    <span className="text-slate-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex justify-center lg:justify-end">
              <a 
                href="#planos"
                className="inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-lg text-lg font-semibold shadow-lg shadow-amber-600/25 hover:shadow-amber-600/40 transition-all hover:-translate-y-0.5"
              >
                Ver Planos Disponíveis
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
